/**
 * Header Navigation Logic
 * Handles mobile menu class toggling and sticky mobile header.
 */

(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        const mobileToggle = document.getElementById('mobile-nav-toggle');
        const body = document.body;
        
        // Cache menu active state to avoid repeated classList.contains() calls
        let isMenuActive = false;

        // --- 1. Mobile Menu Toggling ---
        if (mobileToggle) {
            mobileToggle.addEventListener('click', function (e) {
                e.preventDefault();

                const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    // Close
                    body.classList.remove('mobile-menu-active');
                    mobileToggle.setAttribute('aria-expanded', 'false');
                    isMenuActive = false; // Update cache
                } else {
                    // Open
                    body.classList.add('mobile-menu-active');
                    mobileToggle.setAttribute('aria-expanded', 'true');
                    isMenuActive = true; // Update cache
                }
            });
        }

        // --- 1.5. Submenu Toggling in Mobile Menu ---
        body.addEventListener('click', function (e) {
            // Only handle when mobile menu is active (using cached check)
            if (!isMenuActive) {
                return;
            }

            // Check if clicked element is a menu item with children
            // Works for both main menus and service menu
            const menuItem = e.target.closest('.menu-item-has-children > a, .page_item_has_children > a');

            if (menuItem) {
                e.preventDefault();
                const parentLi = menuItem.parentElement;
                const subMenu = parentLi.querySelector('.sub-menu, .children');

                if (subMenu) {
                    subMenu.classList.toggle('is-open');
                }
            }
        });

        // --- 2. Mobile Header Scroll Behavior (Sticky on Up) ---
        const mobileHeader = document.querySelector('.mobile-header-bar');

        if (mobileHeader) {
            let lastScrollTop = 0;
            const delta = 5; // Minimum scroll to trigger
            const headerHeight = mobileHeader.offsetHeight;
            let ticking = false; // RAF throttling flag

            function updateHeaderVisibility() {
                const st = window.scrollY || document.documentElement.scrollTop;

                // Make sure they scroll more than delta
                if (Math.abs(lastScrollTop - st) <= delta) {
                    ticking = false;
                    return;
                }

                // If they scrolled down and are past the navbar, add class .is-hidden.
                if (st > lastScrollTop && st > headerHeight) {
                    // Scroll Down
                    mobileHeader.classList.add('is-hidden');
                } else {
                    // Scroll Up
                    if (st + window.innerHeight < document.body.scrollHeight) {
                        mobileHeader.classList.remove('is-hidden');
                    }
                }

                lastScrollTop = st;
                ticking = false;
            }

            window.addEventListener('scroll', function () {
                if (!ticking) {
                    window.requestAnimationFrame(updateHeaderVisibility);
                    ticking = true;
                }
            }, { passive: true }); // Passive listener for better scroll performance
        }

        // --- 3. Header Search Toggling ---
        const searchToggles = document.querySelectorAll('.search-toggle');

        searchToggles.forEach(toggle => {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const parent = this.closest('.header-search');
                const dropdown = parent.querySelector('.search-dropdown');
                const input = dropdown.querySelector('input[type="search"]');

                // Close other open search dropdowns if any
                document.querySelectorAll('.search-dropdown.is-visible').forEach(openDropdown => {
                    if (openDropdown !== dropdown) {
                        openDropdown.classList.remove('is-visible');
                    }
                });

                const isVisible = dropdown.classList.toggle('is-visible');
                
                if (isVisible) {
                    setTimeout(() => input.focus(), 100);
                }
            });
        });

        // Close search dropdown when clicking outside
        document.addEventListener('click', function (e) {
            if (!e.target.closest('.header-search')) {
                document.querySelectorAll('.search-dropdown.is-visible').forEach(dropdown => {
                    dropdown.classList.remove('is-visible');
                });
            }
        });

        // Prevent closing when clicking inside the dropdown
        document.querySelectorAll('.search-dropdown').forEach(dropdown => {
            dropdown.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    });

})();
